(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["faq-section"] && !Shopify.designMode) return;
  try {
    
  const faqItems = document.querySelectorAll('.faq-item');
  faqItems.forEach((item, index) => {
    const btn = item.querySelector('.faq-question');
    const answer = item.querySelector('.faq-answer');

    // Always open first FAQ by default
    if(index === 0){
      item.classList.add('active');
      answer.style.maxHeight = answer.scrollHeight + "px";
    }

    btn.addEventListener('click', () => {
      // Close all other FAQs
      faqItems.forEach(f => {
        if(f !== item){
          f.classList.remove('active');
          f.querySelector('.faq-answer').style.maxHeight = "0";
        }
      });

      // Toggle current FAQ
      item.classList.toggle('active');
      if(item.classList.contains('active')){
        answer.style.maxHeight = answer.scrollHeight + "px";
      } else {
        answer.style.maxHeight = "0";
      }
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
